module.exports = __webpack_public_path__ + "img/ff6c151.png";